// ============================================================================
// Hours + minutes ↔ decimal hours helpers
// ============================================================================
// The backend stores time as NUMERIC(6,2) decimal hours. We let users enter
// time as (hours, minutes) and convert. To keep round-tripping clean against
// the 2-decimal storage:
//   - toDecimal rounds to 2 decimal places (matches storage precision)
//   - fromDecimal rounds back to the nearest minute (recovers user intent)
// All 60 minute values 0..59 survive this round-trip.
// ============================================================================

/** (hours, minutes) → decimal hours, rounded to 2 dp. */
export const toDecimalHours = (h: number, m: number): number => {
  const raw = (h || 0) + (m || 0) / 60;
  return Math.round(raw * 100) / 100;
};

/** decimal hours → { h, m } rounded to the nearest minute. */
export const fromDecimalHours = (decimal: number): { h: number; m: number } => {
  const totalMin = Math.round((decimal || 0) * 60);
  return { h: Math.floor(totalMin / 60), m: totalMin % 60 };
};

/** decimal hours → "1h 20m" / "30m" / "2h". Always non-negative. */
export const formatHM = (decimal: number): string => {
  const { h, m } = fromDecimalHours(Math.max(0, decimal || 0));
  if (h === 0 && m === 0) return '0m';
  if (h === 0)            return `${m}m`;
  if (m === 0)            return `${h}h`;
  return `${h}h ${m}m`;
};
